(function () {
  var TARGET = "https://leissing.eu/pages/datenschutz-erklarung";

  function swap() {
    // catch all likely policy links, both relative and absolute
    var links = document.querySelectorAll(
      'a[href*="/policies/privacy-policy"], a[href*="/policies/privacy"], a[href$="/privacy-policy"]'
    );
    links.forEach(function (a) {
      // only change if it's the policy link (avoid unrelated links)
      if (/\/policies\/privacy/i.test(a.getAttribute("href") || "")) {
        a.href = TARGET;
        a.target = "_self";
        a.rel = "noopener noreferrer";
      }
    });
  }

  // run at different times (banner often mounts late)
  document.addEventListener("DOMContentLoaded", swap);
  window.addEventListener("load", swap);

  // watch for dynamically inserted banner
  var mo = new MutationObserver(function () { swap(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // also retry a few times in the first 3 seconds
  var tries = 0;
  var iv = setInterval(function () {
    swap();
    if (++tries > 15) clearInterval(iv);
  }, 200);
})();
